function needsServiceWorkerForTHEOlive() {
  const canPlayMSE = !!(
    window.MediaSource ||
    window.WebKitMediaSource ||
    window.ManagedMediaSource
  );
  const videoElement = document.createElement('video');
  const canPlayHLS =
    videoElement.canPlayType &&
    videoElement.canPlayType('application/vnd.apple.mpegURL') !== '';
  return canPlayHLS && !canPlayMSE;
}

if (needsServiceWorkerForTHEOlive()) {
  console.log('service worker running for iOS version lower than 17.1');
  await navigator.serviceWorker.register('theoplayer.sw.js');
}
